import { cn } from '~/lib/utils'

import StandardText, {
  StandardTextProps
} from '~/components/Text/StandardText/StandardText'
import Image from '~/components/Helpers/Image'
import BlockVideo from '~/components/Media/components/BlockVideo'
import { cva } from 'class-variance-authority'

export interface TextBlockProps {
  content: {
    contentBlock: StandardTextProps['content']
    overlayOpacity?: '0' | '20' | '40' | '60' | '80'
    image: Image
    video?: Asset
    justifyContent?: 'left' | 'centre' | 'right'
    alignItems?: 'centre' | 'bottom'
  }
}

const blockVariants = cva('', {
  variants: {
    overlayOpacity: {
      '80': 'bg-black/80',
      '60': 'bg-black/60',
      '40': 'bg-black/40',
      '20': 'bg-black/20',
      '0': ''
    }
  },
  defaultVariants: {
    overlayOpacity: '60'
  }
})

const ImageTextOverlay = ({ content }: TextBlockProps) => {
  const {
    contentBlock,
    image,
    video,
    overlayOpacity,
    justifyContent,
    alignItems
  } = content

  return (
    <section>
      <div
        className={cn(
          justifyContent === 'right'
            ? 'justify-end text-right'
            : justifyContent === 'left'
              ? 'justify-start'
              : 'justify-center text-center',
          'relative flex max-h-[1080px] min-h-[600px]'
        )}
      >
        <div
          className={cn(
            blockVariants({ overlayOpacity: overlayOpacity || '60' }),
            'absolute inset-0 z-[1]'
          )}
        ></div>
        {video && image ? (
          <BlockVideo
            videoUrl={video.sys.uri}
            width={''}
            height={''}
            image={image}
            className='absolute'
            btnPosition={
              justifyContent === 'right' ? 'bottom-left' : 'bottom-right'
            }
            btnClassName='size-[36px] !p-2xs m-2xs'
          />
        ) : (
          image && <Image image={image} containerClasses='absolute' />
        )}

        <div
          className={cn(
            alignItems === 'bottom'
              ? 'items-end'
              : alignItems === 'centre'
                ? 'items-center'
                : 'items-start',
            'px-s py-m md:p-l lg:p-xl inset-0 flex'
          )}
        >
          <div
            className={cn('space-y-m relative z-10 flex flex-col text-white')}
          >
            <StandardText
              content={{ ...contentBlock, alignment: justifyContent }}
              backgroundColour={'ink-blue'}
              className='flex flex-col [&_a]:text-white [&_p]:max-w-[80ch]'
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default ImageTextOverlay
